const wZero = (value) => (value.toString().length === 1 ? '0' + value : value).toString()

export default function fnFormatTime(time) {
    const [hour, minutes] = time.split(':')
    const hourAMPM = parseInt(hour) > 12 ? wZero(hour - 12) : parseInt(hour) === 0 ? 12 : wZero(hour)

    return hourAMPM + ':' + minutes + (hour >= 12 ? 'pm' : 'am')
}
